<template>
    <div class="form-group and-or-rule row">
        <slot
            name="rules"
            :target="parentPath"
            :rowData="params.form.getDeep(parentPath)"
            v-bind="{
                ...options,
                keyAttrs, opAttrs, valueAttrs,
                keys: params.keys,
                operators: params.operators
            }"
        >
            <div class="col">
                <oc-form-field
                    input="oc-select-input"
                    :target="`${parentPath}.key`"
                    :$options="params.keys"
                    v-bind="keyAttrs"
                    v-on="options.keyEvents"
                />
            </div>

            <div class="col">
                <oc-form-field
                    input="oc-select-input"
                    :target="`${parentPath}.op`"
                    :$options="params.operators"
                    v-bind="opAttrs"
                    v-on="options.opEvents"
                />
            </div>

            <div class="col">
                <oc-form-field
                    input="oc-text-input"
                    :target="`${parentPath}.value`"
                    v-bind="valueAttrs"
                    v-on="options.valueEvents"
                />
            </div>
        </slot>
        <div class="col">
            <oc-button size="small" class="btn-rule" icon="close" @click.prevent="deleteSelf()" />
        </div>
    </div>
</template>

<script>
import {addEvent} from '@/helpers/Utils'

export default {
    name: 'oc-query-builder-rule',
    inject: ['params', '$component'],
    props: {
        parentPath: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            defaultAttrs: {
                displayLabel: false,
                indicationValid: false,
                feedbackUseTooltips: true,
                size: "small"
            }
        }
    },
    methods: {
        deleteSelf() {
            this.$emit('delete-rule')
        }
    },
    computed: {
        options() {
            let options = Object.assign({}, this.params.options)

            if (!options.keyAttrs) options.keyAttrs = {}
            if (!options.opAttrs) options.opAttrs = {}
            if (!options.valueAttrs) options.valueAttrs = {}

            if (!options.keyEvents) options.keyEvents = {}
            if (!options.opEvents) options.opEvents = {}
            if (!options.valueEvents) options.valueEvents = {}

            // add global change event
            let targets = {
                key: 'change',
                op: 'change',
                value: 'input-debounced'
            }

            for (let field in targets) {
                let eventType = targets[field]

                addEvent(options[field+'Events'], eventType, (value, originalEvent) => {
                    this.$component.$emit('change', {
                        field,
                        value,
                        key: `${this.parentPath}.${field}`,
                        originalEvent
                    })
                })
            }

            return options
        },
        keyAttrs() {
            return Object.assign(
                {},
                this.defaultAttrs,
                {
                    $emptyText: "-- Choose Field --"
                },
                this.options.keyAttrs
            )
        },
        opAttrs() {
            return Object.assign(
                {},
                this.defaultAttrs,
                {
                    $emptyText: "-- Choose Operator --"
                },
                this.options.opAttrs
            )
        },
        valueAttrs() {
            return Object.assign(
                {},
                this.defaultAttrs,
                this.options.valueAttrs
            )
        }
    }
}
</script>

<style scoped>
    .and-or-rule {
        position: relative;
        height: 30px;
        margin-left: 15px !important;
        padding-left: 0;
    }

    .and-or-rule:before,
    .and-or-rule:after {
        content: '';
        position: absolute;
        left: -1px;
        width: 16px;
        height: calc(50% + 15px);
        border-color: #6c666e;
        border-style: solid;
    }

    .and-or-rule:before {
        top: -15px;
        border-width: 0 0 2px 2px;
    }

    .and-or-rule:after {
        top: 50%;
        border-width: 0 0 0 2px;
    }

    .and-or-rule:last-child:after {
        border: none;
    }
</style>
